/* ═══════════════════════ Feillogg ═══════════════════════
   Fanger uhåndterte feil og lagrer siste 50 i localStorage.
   Viser toast første gang en feil oppstår i sesjonen — så vet
   Robert at noe gikk galt og kan se diagnostikk under Info.
════════════════════════════════════════════════════════════════ */

const KEY = "ca26-error-log";
const MAX = 50;
let toastShown = false;

export function getErrors(){
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch { return []; }
}

export function clearErrors(){
  try { localStorage.removeItem(KEY); } catch {}
}

function logError(entry){
  try {
    const list = getErrors();
    list.unshift(entry);
    if(list.length > MAX) list.length = MAX;
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {}
  if(!toastShown){
    toastShown = true;
    showErrorToast();
  }
}

function showErrorToast(){
  const t = document.createElement("div");
  t.style.cssText = "position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#dc2626;color:#fff;padding:10px 18px;border-radius:20px;font-size:13px;font-weight:600;z-index:500;box-shadow:0 4px 12px rgba(0,0,0,.3);max-width:300px;text-align:center";
  t.textContent = "⚠️ Noe gikk galt — se Klar → Info → Diagnostikk";
  document.body.appendChild(t);
  setTimeout(()=>t.remove(), 5000);
}

window.addEventListener("error", e => {
  logError({
    ts: new Date().toISOString(),
    type: "error",
    message: String(e.message || ""),
    source: e.filename ? `${e.filename}:${e.lineno}:${e.colno}` : "",
    stack: e.error?.stack ? String(e.error.stack).slice(0, 1000) : "",
    ua: navigator.userAgent.slice(0, 100),
  });
});

window.addEventListener("unhandledrejection", e => {
  logError({
    ts: new Date().toISOString(),
    type: "unhandledrejection",
    message: String(e.reason?.message || e.reason || ""),
    stack: e.reason?.stack ? String(e.reason.stack).slice(0, 1000) : "",
    ua: navigator.userAgent.slice(0, 100),
  });
});
